"use client";

import { useTranslations } from "next-intl";
import { HubTabs } from "@/components/layout/hub-tabs";
import { Wand2, Clapperboard, Disc3, Mic, PenLine, Radio, Headphones, Mic2, BookOpen, Gauge, Grid3x3 } from "lucide-react";

/**
 * Studio hub — one "make" roof over every creation tool. Route group (studio)
 * keeps all URLs (/artwork-studio, /film-maker, /dj, /studio/recorder,
 * /studio/songwriter, /studio/live, /studio/jam-session, /studio/podcast)
 * unchanged; this layout just adds the shared tab strip. Jam Session also lives
 * under the Community hub (/jam-session) — same component, two roofs.
 */
export default function StudioLayout({ children }: { children: React.ReactNode }) {
  const t = useTranslations("studioTabs");
  return (
    <>
      <HubTabs
        share
        tabs={[
          { href: "/artwork-studio", label: t("artwork"), icon: Wand2 },
          { href: "/film-maker", label: t("film"), icon: Clapperboard },
          { href: "/dj", label: t("dj"), icon: Disc3 },
          { href: "/studio/epx", label: t("epx"), icon: Grid3x3 },
          { href: "/studio/recorder", label: t("recorder"), icon: Mic },
          { href: "/studio/songwriter", label: t("songwriter"), icon: PenLine },
          { href: "/studio/live", label: t("live"), icon: Radio },
          { href: "/studio/jam-session", label: t("jam"), icon: Headphones },
          { href: "/studio/podcast", label: t("podcast"), icon: Mic2 },
          { href: "/studio/publisher", label: t("publisher"), icon: BookOpen },
          { href: "/studio/tuner", label: t("tuner"), icon: Gauge },
        ]}
      />
      {children}
    </>
  );
}
